import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AttributesSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AttributesSVG;
